import { render } from "./TabTextEditor.vue?vue&type=template&id=596542bf&scoped=true"
import script from "./TabTextEditor.vue?vue&type=script&lang=js"
export * from "./TabTextEditor.vue?vue&type=script&lang=js"

import "./TabTextEditor.vue?vue&type=style&index=0&id=596542bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596542bf"]])

export default __exports__